import { JobSearchRequest } from "@themuse/design-system";
import { SearchFilters } from "interfaces/context/searchContextInterfaces";
import { removeFalsy } from "./reducers";

interface JobSearchParams {
    filters: SearchFilters,
    companyShortName: string,
    searchKeyword: string,
    remoteOption: string,
    latlng: string,
    cursor?: string,
    searchApiPreference?: string,
    limit?: number
}

type IJoinIfArrayProp = null | string | number | (null | string | number)[];

/**
 * Convert an array to a string with commas.
 */
const joinIfArray = (prop: IJoinIfArrayProp) => (Array.isArray(prop) ? prop.join(",") : prop);

/**
 * Collect the params from both the user inputs and the existing query string.
 * With User params taking precedents.
 * We do not collect the cursor as that is a special circumstance
 */
export const getParams = ({
    filters,
    companyShortName,
    searchKeyword,
    remoteOption,
    latlng,
    cursor,
    searchApiPreference,
    limit = 20
}: JobSearchParams): JobSearchRequest => {
    const inputParams = {
        query: searchKeyword,
        company_short_name: companyShortName,
        level: joinIfArray(filters?.experienceLevel),
        employee_range: joinIfArray(filters?.companySize),
        latlng,
        remote_work_location_type: remoteOption,
        company_industry: joinIfArray(filters?.industry),
        perks_and_benefits: joinIfArray(filters?.perks),
        category: joinIfArray(filters?.category),
        radius: latlng ? filters?.radius : null,
        posted_date_range: filters?.postedDateRange,
        company_leadership_attributes: joinIfArray(filters?.companyLeadership),
        preference: searchApiPreference,
        limit
    };
    // This should really not be here, we need to read this into state properly
    // const queryParams = parseQueryParamsToObject(window.location.search);
    const userParams = removeFalsy(inputParams);
    return {
        start_after: cursor,
        ...userParams
    };
};
